import React from 'react';
import { useRefinementList, UseRefinementListProps } from 'react-instantsearch';

export const VirtualRefinementList: React.FC<UseRefinementListProps> = (props) => {
    useRefinementList(props);

    return null;
};
